export default __webpack_public_path__ + "assets/images/ede74daec140caadfb7feead71fbeca4.jpg";